<app-block-space layout="spaceship-ledge-height"></app-block-space>

<div class="block">
    <div class="container">
        <div class="document">
            <div class="document__header">
                <h1 class="document__title">About Us</h1>
            </div>
            <div class="document__content card">
                <div class="typography" *ngIf="data">
                    <p [innerHtml]="data"></p>
                </div>
            </div>
        </div>
    </div>
</div>

<app-block-space layout="before-footer"></app-block-space>
